<template>
  <b-card>
    <b-row>
      <b-col sm="8" class="pb-1">
        <b-button
          v-if="hasPermission('organization-ids', 'create')"
          variant="outline-primary"
          :to="{ name: 'organization-id-add' }"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-50"
          />
          {{ $t('message.Add_ID') }}
        </b-button>
      </b-col>
      <b-col sm="4">
        <b-form-group>
          <b-form-input
            v-model="searchQuery"
            :placeholder="$t('message.search')"
            type="search"
            class="d-inline-block"
          />
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-table
          ref="refIDListTable"
          :items="ids"
          hover
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty=""
          :empty-text="isLoading ? $t('message.loading') : $t('message.no_records')"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(actions)="data">
            <div class="flex flex-column">
              <EditButton v-if="hasPermission('organization-ids', 'edit')" @clicked="router.push({ name: 'organization-id-edit', params: { id: data.item._id } })"/>
              <DeleteButton v-if="hasPermission('organization-ids', 'delete')" v-b-modal="`modal ${data.item._id}`"/>
              <b-modal
                :id="`modal ${data.item._id}`"
                centered
                no-close-on-backdrop
                modal-class="modal-danger"
                ok-variant="danger"
                cancel-variant="outline-secondary"
                :title="$t('message.confirm_action')"
                :ok-title="$t('message.delete')"
                :cancel-title="$t('message.cancel')"
                @ok="deleteID(data.item._id)"
              >
                {{ $t('message.confirm_delete_id') }}
              </b-modal>
            </div>
          </template>
        </b-table>
      </b-col>

      <b-col
        cols="12"
        class="d-flex justify-content-between flex-wrap"
      >
        <div class="mb-1">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">{{ $t('message.per_page') }}</label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="perPageOptions"
              class="w-50"
            />
          </b-form-group>
        </div>

        <div class="mb-1">
          <span class="text-muted">{{ showingMessage }}</span>
        </div>

        <b-pagination
          v-model="currentPage"
          :total-rows="totalIDs"
          :per-page="perPage"
          first-number=""
          last-number=""
          prev-class="prev-item"
          next-class="next-item"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BPagination, BTable, BModal, VBModal } from 'bootstrap-vue'
import { onMounted } from '@vue/composition-api'
import { useRouter } from '@core/utils/utils'
import EditButton from '@/views/components/Shared/Buttons/EditButton.vue'
import DeleteButton from '@/views/components/Shared/Buttons/DeleteButton.vue'
import useIDList from './useIDList'
import { hasPermission } from '@/composables/usePermission'

export default {
  components: {
    BTable,
    BPagination,
    EditButton,
    DeleteButton,
    BModal,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      items: [],
    }
  },
  setup() {
    const { router } = useRouter()
    const {
      fetchIDs,
      tableColumns,
      perPage,
      currentPage,
      totalIDs,
      showingMessage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      deleteID,
      ids,
      isLoading,
    } = useIDList()

    onMounted(() => {
      fetchIDs()
    })

    return {
      router,
      fetchIDs,
      tableColumns,
      perPage,
      currentPage,
      totalIDs,
      showingMessage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      deleteID,
      ids,
      isLoading,
      hasPermission,
    }
  },
}
</script>

<style lang="scss" scoped>
  .form-group {
    label {
      font-size: 0.85rem;
      font-weight: 400;
    }
  }
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
